import type { RouteRecordRaw } from 'vue-router';
import { BlankLayout } from '@shared/naive-ui';

export default <RouteRecordRaw[]>[
  {
    name: 'missions',
    path: '/missions',
    alias: '/',
    component: () => import('./pages/MissionsPage.vue'),
    meta: {
      layout: BlankLayout,
      scopes: ['operations'],
    },
  },
];
